module.exports = __webpack_public_path__ + "media/images/countdown__background-cef08fa7068800be0b0f7ec14d7375e2.jpg";